'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _information = require('./information.component');

var _information2 = _interopRequireDefault(_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var informationModule = _angular2.default.module('information', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('dashboard.information', {
    url: '/information',
    component: 'information'
  });
}).component('information', _information2.default).name;

exports.default = informationModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.js